/**
 * Catalogos clinicos y demograficos generales.
 *
 * Valores en la forma en que se muestran, sin centinelas: la ausencia de dato
 * es la cadena vacia o `undefined`, no un "None" dentro del catalogo.
 */
export const SEXOS = ['Femenino', 'Masculino', 'Otro'];
export const ESTADOS_CIVILES = ['Soltera', 'Casada', 'Unión libre', 'Viuda', 'Divorciada'];
export const ESCOLARIDADES = [
    'Ninguna',
    'Básica',
    'Media',
    'Media superior',
    'Superior',
    'Postgrado',
];
/** Escala usada en antecedentes: se distingue "no preguntado" de "negado". */
export const RESPUESTA_ANTECEDENTE = ['No preguntado', 'Niega', 'Refiere'];
export const ENFERMEDADES_CRONICAS = [
    'Diabetes mellitus',
    'Hipertension arterial',
    'Hipotiroidismo',
    'Hipertiroidismo',
    'Cardiopatía',
    'Nefropatía',
    'Hepatopatía',
    'Cancer',
    'Inmunosupresión',
    'VIH',
    'Otra',
];
export const METODOS_ANTICONCEPTIVOS = [
    'Ninguno',
    'Hormonal oral',
    'Hormonal inyectable',
    'Implante subdérmico',
    'DIU de cobre',
    'DIU hormonal',
    'Preservativo',
    'Oclusión tubaria bilateral',
    'Vasectomía de la pareja',
    'Ritmo o calendario',
    'Otro',
];
export const INFECCIONES_TRANSMISION_SEXUAL = [
    'VPH',
    'Herpes genital',
    'Clamidia',
    'Gonorrea',
    'Sífilis',
    'Tricomoniasis',
    'VIH',
    'Hepatitis B',
    'Otra',
];
export const VACUNAS = ['VPH', 'Hepatitis B', 'Influenza', 'COVID-19', 'Tétanos', 'Otra'];
/** Resultado de citología cervical, terminologia Bethesda. */
export const RESULTADOS_CITOLOGIA = [
    'Negativo para lesión intraepitelial',
    'ASC-US',
    'ASC-H',
    'LSIL',
    'HSIL',
    'AGC',
    'Adenocarcinoma in situ',
    'Carcinoma',
    'Insatisfactoria',
];
export const RESULTADOS_VPH = [
    'Negativo',
    'Positivo alto riesgo',
    'Positivo 16',
    'Positivo 18',
    'Positivo 16 y 18',
    'Positivo otros tipos',
    'No concluyente',
];
export const RESULTADOS_BIOPSIA = [
    'Negativo',
    'Cervicitis crónica',
    'NIC 1',
    'NIC 2',
    'NIC 3',
    'Carcinoma in situ',
    'Carcinoma invasor',
    'Adenocarcinoma',
    'Insuficiente para diagnóstico',
];
//# sourceMappingURL=clinico.js.map